import React from 'react';
import { useScrollAnimation } from '../hooks/useScrollAnimation';
import { COMPANY_FACTS } from '../data/company';
import SectionHead from './SectionHead';
import MultilineText from './MultilineText';
import layout from '../styles/layout.module.css';
import styles from './CompanyInfoSection.module.css';

const CompanyInfoSection: React.FC = () => {
  const { elementRef, isVisible } = useScrollAnimation<HTMLDivElement>();

  return (
    <section
      id="company-info"
      className={layout.section}
      aria-labelledby="company-info-title"
    >
      <div
        ref={elementRef}
        className={`${layout.wrap} ${layout.sectionInner} slide-up ${isVisible ? 'visible' : ''}`}
      >
        <SectionHead
          eyebrow="COMPANY"
          title="会社概要"
          titleId="company-info-title"
          lead="石川県金沢市を拠点に、全国のお客様へ。"
        />

        <div className={styles.grid}>
          <dl className={styles.facts}>
            {COMPANY_FACTS.map((fact) => (
              <div key={fact.label} className={styles.row}>
                <dt className={styles.term}>{fact.label}</dt>
                <dd className={styles.detail}>
                  {fact.isAddress ? (
                    <address className={styles.address}>
                      <MultilineText text={fact.value} />
                    </address>
                  ) : (
                    <MultilineText text={fact.value} />
                  )}
                </dd>
              </div>
            ))}
          </dl>

          <div className={styles.about}>
            <h3 className={styles.aboutTitle}>eNEW Studio について</h3>
            <p className={styles.aboutText}>
              石川県金沢市を拠点に、全国のお客様にクラウドソリューションを提供しています。元
              AWS 社員としての知見と AWS 認定 12
              冠の技術力を活かし、お客様の事業規模に合った、無理のない最適なクラウド設計を提案します。
            </p>
            <p className={styles.aboutText}>
              大規模な開発会社ではありません。その分、小回りの利く機動力と、契約が終わっても困らない引き継ぎをお約束します。
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default CompanyInfoSection;
